import { render, staticRenderFns } from "./CryptoDepositFormOvyPay.vue?vue&type=template&id=5d388b3a"
import script from "./CryptoDepositFormOvyPay.vue?vue&type=script&lang=js"
export * from "./CryptoDepositFormOvyPay.vue?vue&type=script&lang=js"
import style0 from "./CryptoDepositFormOvyPay.vue?vue&type=style&index=0&id=5d388b3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports